module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/et-061591dd14f8c02c150f57d14cabd671.svg";